import axios from "axios";
import router from "@/router/router"
// import qs from "qs";
import { getMode } from "@/utils/utils";
const bareToken =
  "Basic bmV3LWVuZXJneS1jbGllbnQtaWQ6bmV3LWVuZXJneS1jbGllbnQtaWQ=";
const baseUrl = "/new-energy-api";

console.log(getMode);

const service = axios.create({
  baseURL: baseUrl,
  timeout: 200000,
});

service.interceptors.request.use(
  (config: any) => {
    if (
      config.data &&
      Object.prototype.toString.call(config.data).includes("FormData")
    ) {
      Object.assign(config.headers, {
        "Content-Type": "multipart/form-data",
      });
    } else {
      Object.assign(config.headers, {
        "Content-Type": "application/json",
      });
      // if (config.method === "post") {
      //   config.data = qs.stringify(config.data);
      // }
    }

    const userToken = localStorage.getItem("user-token") || bareToken;
    if (userToken) {
      config.headers["Authorization"] = userToken;
    }
    return config;
  },
  (err: any) => {
    return Promise.reject(err);
  }
);

service.interceptors.response.use(
  (response: any) => {
    // console.log(response,'成功')
    return Promise.resolve(response);
  },
  (err: any) => {
    // console.log(err,'错误')
    if (err == "Error: Request failed with status code 401") {
      localStorage.removeItem("user-token")
      router.push('/login')// 注意，这里使用了Vue的全局实例
    }
    return Promise.reject(err);
  }
);

export default service;
